export default __webpack_public_path__ + "static/media/011_photo.f5c8a7e4.jpg";